import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { GetLinkedInFeedResponse } from '@3m5/sm_publish-frontend-api/models'

import { ApiError } from '../../store/postingRoot.reducer'

import {
  getLinkedInFeed,
} from './linkedIn.actions'

export interface LinkedInState {
  linkedInFeeds?: GetLinkedInFeedResponse
  error: ApiError
}

const INITIAL_STATE: LinkedInState = {
  error: {},
}

export const linkedInReducer = reducerWithInitialState(INITIAL_STATE)

  /**
   * getFacebookFeedForPage
   */
  .case(getLinkedInFeed.started, state => {
    return produce(state, draft => {
      delete draft.error.loadLinkedInFeedForPage
    })
  })

  .case(getLinkedInFeed.done, (state, { result }) => {
    return produce(state, draft => {
      draft.linkedInFeeds = result
    })
  })

  .case(getLinkedInFeed.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.error.loadLinkedInFeedForPage = (error as Response)
    })
  })
